import { render } from "./Reportes.vue?vue&type=template&id=2f76b8e4"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"
script.render = render

export default script